// import React from 'react';
// import { Outlet } from 'react-router-dom';
// import ServiceProvDrawer from './ServiceProvDrawer';

// const ServiceProvDashLayout = () => {
//     const styles = `
//   .layout-container {
//     display: flex;
//   }

//   .main-content {
//     flex-grow: 1;
//     padding-top: 35px;
//     margin-top: 5px; /* Only applies on large devices */
//     margin-inline: 0px;
//   }

//   @media (max-width: 768px) {
//     .layout-container {
//       display: block;
//     }

//     .main-content {
//       flex-grow: 0;
//       padding-top: 0px; /* Remove top padding */
//       margin-top: 0px;  /* Remove top margin */
//     }
//   }
// `;

//     return (
//         <>
//             <style>{styles}</style>
//             <div className="layout-container">
//         <ServiceProvDrawer>
//           <main className="main-content">
//             <Outlet />
//           </main>
//         </ServiceProvDrawer>
//       </div>
//         </>
//     );
// }

// export default ServiceProvDashLayout;


import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import ServiceProvDrawer from './ServiceProvDrawer';

const ServiceProvDashLayout = () => {
    const styles = `
  .layout-container {
    display: flex;
  }

  .main-content {
    flex-grow: 1;
    padding-top: 35px;
    margin-top: 5px; /* Only applies on large devices */
    margin-inline: 0px;
  }

  @media (max-width: 768px) {
    .layout-container {
      display: block;
    }

    .main-content {
      flex-grow: 0;
      padding-top: 0px; /* Remove top padding */
      margin-top: 0px;  /* Remove top margin */
    }
  }
`;

    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <>
            <style>{styles}</style>
            <div className="layout-container">
        <ServiceProvDrawer>
          <main className="main-content">
            <Outlet />
          </main>
        </ServiceProvDrawer>
      </div>
        </>
    );
}

export default ServiceProvDashLayout;